import React from "react";
import "../KVKK/KVKK.css";

const CerezPolitikasi = () => {
  return (
    <div className="kvkk-page">
      <section className="kvkk-hero">
        <h1>Çerez <span>Politikası</span></h1>
        <p className="kvkk-hero-url">www.lingify.co</p>
      </section>

      <div className="kvkk-content">
        <div className="kvkk-container">

          <h2>Çerez Nedir?</h2>
          <p>Ziyaret ettiğiniz sitelerin tarayıcınıza bıraktığı küçük metin dosyalarıdır.</p>

          <h2>Sitemizde Ne Tür Çerez Kullanılıyor?</h2>
          <p>Yalnızca <strong>zorunlu (teknik) çerezler</strong> kullanılmaktadır. Analitik, reklam veya üçüncü taraf izleme çerezi yoktur. Bu çerezler sitenin çalışması için zorunlu olduğundan açık rıza gerekmez (meşru menfaat, KVKK m.5/2-f).</p>

          <table className="kvkk-data-table">
            <thead>
              <tr>
                <th>Çerez</th>
                <th>Amacı</th>
                <th>Süresi</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Oturum çerezi</td>
                <td>Oturum yönetimi, formların çalışması</td>
                <td>Tarayıcı kapatıldığında</td>
              </tr>
              <tr>
                <td>Güvenlik çerezi (CSRF)</td>
                <td>Formların yetkisiz gönderime karşı korunması</td>
                <td>Tarayıcı kapatıldığında</td>
              </tr>
              <tr>
                <td>Çerez tercih çerezi</td>
                <td>Ziyaretçinin çerez tercihinin hatırlanması</td>
                <td>1 yıl</td>
              </tr>
            </tbody>
          </table>

          <h2>Çerezleri Kapatabilir miyim?</h2>
          <p>Tarayıcı ayarlarınızdan çerezleri reddedebilir veya silebilirsiniz. Ancak zorunlu çerezler kapatılırsa site düzgün çalışmayabilir.</p>

          <h2>Değişiklikler</h2>
          <p>İlerleyen dönemde analitik veya pazarlama çerezi eklenirse bu politika güncellenecek ve gerekli durumlarda onayınız istenecektir.</p>

          <h2>İletişim</h2>
          <p><strong>E-posta:</strong> info@lingify.co</p>
        </div>
      </div>
    </div>
  );
};

export default CerezPolitikasi;
